<template>
    <f-modal :visible="isVisible"
             class="alm-calm-modal"
             @ok="confirm"
             @update:visible="(vis) => setVisible(vis)">
        <f-spin :spinning="spinning" >
            <div class="calm-title">
                <img id="logo" v-bind:src="appLogo" height="32" width="32" />
                <h3>{{isEditView? `${localizer.Localize('Edit')} ${currentChangeset?.name}` : localizer.Localize('LandscapeManagementManage_NewChangeSet')}}</h3>
            </div>
            <f-tabs class="alm-calm-tabs" :icons="true" :activeKey="activeTabKey">
                <f-tab-pane class="alm-forms-tab" icon="member" :key="1">
                    <f-form class="calm-form" @submit="checkForm">
                        <f-form-item :label="localizer.Localize('Name')"
                                     :class="{ 'has-error': submitted && calmModelErrors.name.length }"
                                     required>
                            <f-input v-model:value="calmModel.name"
                                     @keyup="checkNameSpecialCharacters"
                                     :disabled="isEditView"
                                     :placeholder="localizer.Localize('LandscapeManagementManage_EnterAChangeSetName')" />
                            <div>
                                <p class="form-input-description"
                                   v-if="localizer.Localize('LandscapeManagementManage_DescribeWhatKind')">
                                    {{localizer.Localize('LandscapeManagementManage_DescribeWhatKind')}}
                                </p>
                                <p class="form-input-description error-description"
                                   v-for="errorText in calmModelErrors.name">
                                    {{ errorText }}
                                </p>
                            </div>
                        </f-form-item>
                        <f-form-item :label="localizer.Localize('LandscapeManagementManage_Description_Field')"
                                     :class="{ 'has-error': submitted && calmModelErrors.description.length }">
                            <textarea class="f-textarea"
                                      @keyup="checkDescriptionInput"
                                      v-model.value="calmModel.description"
                                      type="textarea"
                                      :placeholder="localizer.Localize('LandscapeManagementManage_DescribeYourChange')"/>
                            <div>
                                <p class="form-input-description"
                                   v-if="localizer.Localize('LandscapeManagementManage_DescribeWhatKind')">
                                    {{localizer.Localize('LandscapeManagementManage_DescribeWhatKind')}}
                                </p>
                                <p class="form-input-description error-description"
                                   v-for="errorText in calmModelErrors.description">
                                    {{ errorText }}
                                </p>
                            </div>
                        </f-form-item>
                        <f-form-item :label="localizer.Localize('LandscapeManagementManage_Source')"
                                     required
                                     :class="{ 'has-error': submitted && calmModelErrors.source.length }">
                            <f-select-standard :options="sourceTenantsOption"
                                               @change="checkSourceSelect"
                                               v-model:value="calmModel.source"
                                               :disabled="isEditView"
                                               :placeholder="localizer.Localize('Select')" />
                            <div>
                                <p class="form-input-description">
                                    {{localizer.Localize('LandscapeManagementManage_YouMustSelectSource')}}
                                </p>
                                <p class="form-input-description error-description"
                                   v-for="errorText in calmModelErrors.source">
                                    {{ errorText }}
                                </p>
                            </div>
                        </f-form-item>
                        <f-form-item :label="localizer.Localize('LandscapeManagementManage_Target')"
                                     required
                                     :disabled="!calmModel.source"
                                     :class="{ 'has-error': submitted && calmModelErrors.target.length }">
                            <!-- TO Do : Use this multiselect component after upgrading uicomponents package to 2.0.36 after july release
                                     <f-select-standard :options="targetTenantsOption"
                                                :showSearch="true"
                                                :multiselect="true"
                                                :disabled="!calmModel.source"
                                                @change="checkTargetSelect"
                                                v-model:values="calmModel.target"
                                                :placeholder="localizer.Localize('Select')" /> -->
                                    <MultiSelectDropdown
                                        v-model="selectedItems"
                                        :options="targetTenantsOption"
                                        :disabled="!calmModel.source"
                                    />
                            <div>
                                <p class="form-input-description">
                                    {{localizer.Localize('LandscapeManagementManage_YouMustSelectTarget')}}
                                </p>
                                <p class="form-input-description error-description"
                                   v-for="errorText in calmModelErrors.target">
                                    {{ errorText }}
                                </p>
                            </div>
                        </f-form-item>
                    </f-form>
                </f-tab-pane>
                <f-tab-pane icon="member" :key="2">
                    <div class="calm-items-wrapper">
                        <div class="calm-left-sidebar">
                            <f-search-bar v-model:value="search"
                                          :activeIndex="activeIndex"
                                          :count="searchCount"
                                          @next="moveToNext"
                                          @prev="moveToPrevious"
                                          class="calm-search"
                                          placeholder="Search"/>
                            <FileSystemObject v-if="root"
                                              :isAlm="true"
                                              class="mt1"
                                              :Fso="root"
                                              :ChangeUrlOnSelect="false"
                                              :CanUserExpand="true"
                                              :CanUserSelect="true"
                                              :HighlightSearchResults="true"
                                              :CanUserOpenWithDoubleClick="true" />
                        </div>
                        <div class="calm-center-content">
                            <div class="calm-center-toolbar">
                                <div class="calm-center-toolbar-title">
                                    <h2>{{calmModel?.name}}</h2>
                                    <div class="calm-center-toolbar-right-section">
                                        <div class="calm-center-toolbar-source-content">
                                            <h4>{{`${localizer.Localize('LandscapeManagement_Source')}:`}}</h4>
                                            <span>{{getTenantNameById(calmModel?.source)}}</span>
                                        </div>
                                        <div class="calm-center-toolbar-items-content">
                                            <h4>{{selectedFsoChildren?.length}}</h4>
                                            <span>{{localizer.Localize('LandscapeManagement_Items_Text')}}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="calm-breadcrumb">
                                    <f-breadcrumb :items="breadcrumbs"></f-breadcrumb>
                                </div>
                            </div>
                            <div class="child-fso-header" v-show="selectedFsoChildren.length">
                                <span>
                                    <f-checkbox text="Checkbox" @change="toggleFsoChild($event?.target?.checked, selectedFso)"
                                                :indeterminate="selectedFso.almIntermediateChecked"
                                                :checked="selectedFso.almChecked"/>
                                </span>
                                <span class="flex-grow-1">
                                    {{localizer.Localize('Explorer_Name')}}</span>
                                <span class="w-60">{{localizer.Localize('Explorer_Type')}}</span>
                                <span class="w-150">{{localizer.Localize('Explorer_Date_Modified')}}</span>
                            </div>
                            <div class="explorerContent" v-if="!selectedFsoChildren || selectedFsoChildren.length === 0">
                                <Empty>{{localizer.Localize("EditOfficeReportPanel_Nothing_Selected")}}</Empty>
                            </div>
                            <div v-for="(child, i) in selectedFsoChildren"
                                :key="child.id"
                                class="fso-wrapper">
                                <f-checkbox :checked="child.almChecked"
                                            :indeterminate="child.almIntermediateChecked"
                                            @change="toggleFsoChild($event?.target?.checked, child)">
                                    <FileSystemObject :Fso="child"
                                                      :CanUserExpand="false"
                                                      :isAlm="true"
                                                      :CanUserSelect="false"
                                                      :ChangeUrlOnSelect="false"
                                                      :HideExpander="true"
                                                      :HighlightSearchResults="true"
                                                      :CanUserOpenWithDoubleClick="false"
                                                      :Secondary="true" />
                                </f-checkbox>
                            </div>
                        </div>
                        <div class="calm-right-sidebar">
                            <CalmRightSideSection @toggleFsoChild="toggleFsoChild" />
                        </div>
                    </div>
                </f-tab-pane>
            </f-tabs>
        </f-spin>
        <template v-slot:footer>
            <div class="flex justify-end">
                <f-button text="Button" type="default" @click="setVisible(false)">
                    {{ localizer.Localize('Cancel_PascalCase') }}
                </f-button>
                <f-button text="Button"
                          type="ghost"
                          @click="save"
                          class="ml3">
                    {{ localizer.Localize('Save_CamelCase') }}
                </f-button>
                <f-button v-show="activeTabKey === 1"
                          text="Button"
                          type="primary"
                          @click="goToSecondTab"
                          class="ml3">
                    {{localizer.Localize('DimensionMemberSelector_Move_To_Next')}}
                </f-button>
                <f-button v-show="activeTabKey === 2"
                          text="Button"
                          type="primary"
                          @click="saveAndClose"
                          class="ml3">
                    {{localizer.Localize('DimensionMemberSelector_Move_To_Next')}}
                </f-button>
            </div>
        </template>
    </f-modal>
</template>

<script lang="ts">
import {defineComponent} from 'vue';
import {mapGetters, mapActions, mapMutations} from 'vuex';
import {Localizer} from '@/api/Localizer';
import {
    IAlmFileSystemObjectContent,
    IBreadcrumb,
    ICalmModel,
    ICalmModelErrors,
    IChangesetDetails,
    IToolbarDropdown
} from '@/components/pages/landscape/LandscapeManagementInterfaces';
import {ChangeSetDTO, TenantDTO} from "@/api/ApiClient";
import * as api from "@/api/ApiClient";
import FileSystemObject from "@/components/pages/explorer/FileSystemObject.vue";
import Empty from "@/components/helpers/Empty.vue";
import Checkbox from "@/components/helpers/Checkbox.vue";
import {getDeepErrorMessage} from "@/utils/Utils";
import CalmRightSideSection from '@/components/pages/landscape/CalmRightSideSection.vue';
import MultiSelectDropdown from '@/components/helpers/MultiSelectDropdown.vue';

const MAX_NAME_LENGTH = 100;
const MAX_DESCRIPTION_LENGTH = 250;

export default defineComponent({
    components: {
        Checkbox,
        FileSystemObject,
        Empty,
        CalmRightSideSection,
        MultiSelectDropdown
    },
    data() {
        return {
            spinning: false,
            calmModel: {
                name: '',
                description: '',
                source: '',
                target: []
            } as ICalmModel,
            calmModelErrors: {
                name: [],
                description: [],
                source: [],
                target: []
            } as ICalmModelErrors,
            localizer: new Localizer(this.$store),
            selectedItem: {},
            submitted: false,
            sourceTenantsOption: [] as Array<IToolbarDropdown>,
            targetTenantsOption: [] as Array<IToolbarDropdown>,
            activeTabKey: 1 as number,
            itemsCount: 0,
            SearchResults: [] as api.FileSystemObjectContent[],
            activeIndex: -1,
            searchCount: 0,
            filterTenants: '',
            selectedItems: [] as Array<string | number>,
            createdChangesetId: null as string | null
        }
    },
    props: {
        isVisible: Boolean,
        isEditView: Boolean,
        currentChangeset: Object
    },
    watch: {
        isVisible: {
            handler(newVal: boolean) {
                if (newVal) {
                    this.resetModal();
                }
            },
            immediate: true
        },
        SearchResults(newVal) {
            this.searchCount = newVal?.length;
        },
        SearchText() {
            this.SearchResults = this.getSearchResults();
            if (this.SearchResults?.length === 0) {
                this.activeIndex = -1;
                this.SetCurrentSearchResult(null);
            }
            else {
                this.selectResult(0);
            }
        },
        selectedItems(newVal) {
            this.calmModel.target = newVal;
            this.checkTargetSelect();
        },
        root(newVal) {
            if(this.isEditView && newVal){
                const checkFolderContent = (folder: IAlmFileSystemObjectContent) => {
                    folder.folderContent?.forEach((child: IAlmFileSystemObjectContent) => {
                        if (this.changesetItemIds?.includes(child.id)) {
                            this.toggleFsoChild(true, child);
                        }
                        if (child.folderContent) {
                            checkFolderContent(child);
                        }
                    });
                };
                checkFolderContent(newVal);
            }
        },
    },
    computed: {
        ...mapGetters('security', [
            'almTenants'
        ]),
        ...mapGetters('alm', [
            'newChangeset',
            'selectedFiles',
            'changesetItemIds'
        ]),
        ...mapGetters('explorer', [
            'SearchText',
            "getSearchResults",
            'selectedFso',
            'getFsoByPath',
            'root',
            'getFsoParentById'
        ]),
        appLogo() {
            return this.$store.state.Theme['--main-logo'];
        },
        search: {
            get() {
                return this.SearchText
            },
            set(newValue: string) {
                this.SetSearchText(newValue);
            }
        },
        selectedFsoChildren(): Array<IAlmFileSystemObjectContent> {
            if (this.selectedFso != null && this.selectedFso.folderContent != null) {
                return this.selectedFso.folderContent
                    .filter((file:IAlmFileSystemObjectContent) => {
                        return !file.isGlobal;
                    })
                    .sort((a:IAlmFileSystemObjectContent, b:IAlmFileSystemObjectContent) => {
                        let ord = a.name!.localeCompare(b.name!);
                        if ( a.objectType == api.FileSystemType.Folder) {
                            ord -= 100;
                        }

                        if (b.objectType == api.FileSystemType.Folder) {
                            ord += 100;
                        }

                        return ord;
                    });
            }
            else {
                return new Array<IAlmFileSystemObjectContent>();
            }
        },
        breadcrumbs():Array<IBreadcrumb> {
            if (!this.selectedFso) {
                return [];
            }
            const arr:Array<string> = this.selectedFso.fullPath.split('/').filter((fileName:string) => {
                return !!fileName;
            });
            let breadcrumbs:Array<IBreadcrumb> = [{
                title: this.localizer.Localize('DashboardView_Files'),
                key: -1,
                action: this.selectBC.bind(null, '')
            }]
            let path = '';
            arr.forEach((title:string, i: number) => {
                path += `/${title}`;
                breadcrumbs.push({
                    title,
                    key: i,
                    action: this.selectBC.bind(null, path)
                })
            })
            return breadcrumbs;
        }
    },
    async mounted() {
        try {
            this.spinning = true;
            await this.getAlmTenants();
        } catch (e) {
            console.error(e)
            this.spinning = false;
            await this.ShowToast(new api.ToastNotification({
                message: this.localizer.Localize('LogMessageActivityEditor_Error'),
                type: api.ToastType.Error
            }));
            return;
        }

        this.sourceTenantsOption = [];
        this.targetTenantsOption = [];
        this.almTenants?.forEach((tenant: TenantDTO) => {
            if (tenant.isALMSource) {
                this.sourceTenantsOption.push({
                    value: tenant.id,
                    label: tenant.name || ''
                });
            }
            if (tenant.isALMTarget) {
                this.targetTenantsOption.push({
                    value: tenant.id,
                    label: tenant.name || ''
                })
            }
        });
        await this.$nextTick();
        this.spinning = false;
        if(this.isEditView && this.currentChangeset){
           // Resolve to the option's own value so the model and the dropdown always agree on id type.
           const targetTenantIds = this.currentChangeset.detail?.map((tenantDetails: IChangesetDetails) => {
               const optionById = this.targetTenantsOption?.find(
                   (option: IToolbarDropdown) => String(option.value) === String(tenantDetails?.tenantId));
               if (optionById) {
                   return optionById.value;
               }
               const optionByName = this.targetTenantsOption?.find(
                   (option: IToolbarDropdown) => option.label === tenantDetails?.tenant);
               return optionByName ? optionByName.value : null;
           })?.filter((id: string | number | null) => id !== null && id !== undefined);
           this.selectedItems = [...targetTenantIds];
            this.calmModel = {
                name: this.currentChangeset.name || '',
                description: this.currentChangeset.description || '',
                source: this.currentChangeset.sourceId,
                target: [...targetTenantIds]
            };
        }
    },
    methods: {
        ...mapActions('security', [
            'getAlmTenants'
        ]),
        ...mapActions('alm', [
            'getRoot',
            'submitNewChangeset',
            'getChangesets',
            'updateChangeset',
            'fetchChangesetItems'
        ]),
        ...mapActions(['ShowToast']),
        ...mapActions('explorer', [
            'ExpandExplorerFolders'
        ]),
        ...mapMutations('alm', [
            'setNewChangeset',
            'setSelectedAlmChangesets'
        ]),
        ...mapMutations('explorer', [
            'SetSearchText',
            'SelectFso',
            'LoadFileSystem',
            'SetCurrentSearchResult',
            'SetFileSystem'
        ]),
        setVisible(val: boolean) {
            this.$emit('close', val);
        },
        resetModal() {
            this.resetCalmModelErrors();
            this.SetSearchText("");
            this.SelectFso(null);
            this.calmModel = {
                name: '',
                description: '',
                source: '',
                target: []
            };
            this.submitted = false;
            this.activeTabKey = 1;
            this.spinning = false;
            this.createdChangesetId = null;
            this.setNewChangeset(null);
            this.SetFileSystem(null);
        },
        checkNameSpecialCharacters() {
            if (!this.submitted) {
                return;
            }
            this.calmModelErrors.name = [];

            if (!this.calmModel.name.trim().length) {
                this.calmModelErrors.name.push(this.localizer.Localize('LandscapeManagementManage_ValidationRequiredField'));
            }

            if (this.calmModel.name.length > MAX_NAME_LENGTH) {
                this.calmModelErrors.name.push(this.localizer.Localize('LandscapeManagementManage_ValidationMaximum100Characters'));
            }
            if (this.hasSpecialCharacters(this.calmModel.name)) {
                this.calmModelErrors.name.push(this.localizer.Localize('LandscapeManagementManage_ValidationNoSpecialCharacters'));
            }
        },
        checkDescriptionInput() {
            if (!this.submitted) {
                return;
            }
            this.calmModelErrors.description = [];

            if (this.calmModel.description.length > MAX_DESCRIPTION_LENGTH) {
                this.calmModelErrors.description.push(this.localizer.Localize('LandscapeManagementManage_ValidationChangesetDescription'));
            }
        },
        async checkTargetSelect() {
            if (!this.submitted) {
                return;
            }
            this.calmModelErrors.target = [];
            await this.$nextTick();

            if (this.calmModel.target?.includes(this.calmModel.source)) {
                this.calmModelErrors.target.push(this.localizer.Localize('LandscapeManagementManage_ValidationTarget'));
            }
            if (!this.calmModel.target || this.calmModel.target.length === 0) {
                this.calmModelErrors.target.push(this.localizer.Localize('LandscapeManagementManage_ValidationRequiredField'));
            }
        },
        async checkSourceSelect() {
            if (!this.submitted) {
                return;
            }
            this.calmModelErrors.source = [];
            await this.$nextTick();

            if (!this.calmModel.source) {
                this.calmModelErrors.source.push(this.localizer.Localize('LandscapeManagementManage_ValidationRequiredField'));
            }
        },
        checkForm():void {
            this.resetCalmModelErrors();

            this.checkNameSpecialCharacters();

            this.checkDescriptionInput();

            this.checkTargetSelect();

            this.checkSourceSelect();
        },
        isInEditMode(): boolean {
            return this.isEditView || !!this.createdChangesetId;
        },
        getChangesetId(): string | null {
            return this.isEditView ? this.currentChangeset?.id : this.createdChangesetId;
        },
        async persistChangeset(): Promise<void> {
            const changesetId = this.getChangesetId();
            if (changesetId) {
                await this.updateChangeset(changesetId);
            } else {
                const changeset = await this.submitNewChangeset();
                if (changeset?.id) {
                    this.createdChangesetId = changeset.id;
                }
            }
            await this.getChangesets();
        },
        async save() {
            this.submitted = true;
            this.spinning = true;
            this.checkForm();
            if (await this.hasCalmModelErrors()) {
                this.spinning = false;
                return;
            }
            const hasItems = this.selectedFiles?.length > 0;
            this.setNewChangeset({
                name: this.calmModel.name,
                description: this.calmModel.description,
                targetTenantIds: this.calmModel.target,
                sourceTenantId: this.calmModel.source,
                isDraft: !hasItems
            });
            try {
                await this.persistChangeset();
                await this.ShowToast(new api.ToastNotification({
                    message: this.localizer.Localize(this.isInEditMode() ? 'LandscapeManagement_EditChangesetSuccess' : 'LandscapeManagement_CreateChangesetSuccess'),
                    type: api.ToastType.Success
                }));
            } catch (e) {
                const errorMessage = getDeepErrorMessage(e);
                await this.ShowToast(new api.ToastNotification({
                    message: errorMessage || this.localizer.Localize(this.isInEditMode() ? 'LandscapeManagement_EditChangesetError' : 'LandscapeManagement_CreateChangesetError'),
                    type: api.ToastType.Error
                }));
            } finally {
                this.spinning = false;
            }
        },
        async saveAndClose() {
            await this.save();
            if (!await this.hasCalmModelErrors()) {
                this.setSelectedAlmChangesets(null);
                this.setVisible(false);
            }
        },
        async goToSecondTab() {
            this.submitted = true;
            this.spinning = true;
            this.checkForm();
            if (await this.hasCalmModelErrors()) {
                this.spinning = false;
                return;
            }
            const hasItems = this.selectedFiles?.length > 0;
            this.setNewChangeset({
                name: this.calmModel.name,
                description: this.calmModel.description,
                targetTenantIds: this.calmModel.target,
                sourceTenantId: this.calmModel.source,
                isDraft: !hasItems
            });
            try {
                await this.persistChangeset();
                (this.isEditView || this.createdChangesetId) && await this.fetchChangesetItems();
                await this.getRoot(this.getTenantNameById(this.calmModel.source));
                this.spinning = false;
                this.activeTabKey = 2;
            } catch (e) {
                const errorMessage = getDeepErrorMessage(e);
                await this.ShowToast(new api.ToastNotification({
                    message: errorMessage || this.localizer.Localize('LogMessageActivityEditor_Error'),
                    type: api.ToastType.Error
                }));
                this.spinning = false;
            }
        },
        async hasCalmModelErrors():Promise<boolean> {
            await this.$nextTick();

            return Object.values(this.calmModelErrors).some((errors:string[]) => {
                return errors.length;
            });
        },
        hasSpecialCharacters(text:string):boolean {
            if (!text) {
                return false;
            }
            const specialsRegEx = /[^A-Za-z\s0-9_]/g;
            return specialsRegEx.test(text);
        },
        resetCalmModelErrors() {
            this.calmModelErrors = {
                name: [],
                description: [],
                source: [],
                target: []
            };
        },
        async selectBC(path:string) {
            if (!path) {
                await this.ExpandExplorerFolders({ targetFso: this.root, secondary: false });
                this.SelectFso(this.root);
                return;
            }

            const fso = await this.getFsoByPath(path);
            await this.ExpandExplorerFolders({ targetFso: fso, secondary: false });
            this.SelectFso(fso);

        },
        async moveToNext() {
            let activeIndex = this.activeIndex + 1;
            if (activeIndex < this.SearchResults.length) {
                await this.selectResult(activeIndex);
            }
        },
        async moveToPrevious() {
            let activeIndex = this.activeIndex - 1;
            if (activeIndex >= 0 && this.SearchResults?.length > 0) {
                await this.selectResult(activeIndex);
            }
        },
        async selectResult(activeIndex: number) {
            this.activeIndex = activeIndex;
            this.SetCurrentSearchResult(this.SearchResults[activeIndex]);
            let targetFso = this.getFsoParentById(this.SearchResults[activeIndex]?.id) as api.FileSystemObject;
            this.ExpandExplorerFolders({ targetFso: targetFso, secondary: false });
            this.SelectFso(targetFso);
        },
        toggleFsoChild($event: boolean, fsoChild:IAlmFileSystemObjectContent) {
            const value: boolean = $event;
            const toggleAllFsoChildrens = (child: IAlmFileSystemObjectContent) => {
                if(!child) {
                    return;
                }
                child.almChecked = value;
                child.almIntermediateChecked = false;
                child.folderContent?.forEach((fso: IAlmFileSystemObjectContent) => {
                    fso.almChecked = value;
                    child.almIntermediateChecked = false;
                    if (fso.folderContent && fso.folderContent.length) {
                        toggleAllFsoChildrens(fso);
                    }
                })
            }
            const toggleAllFsoParents = (fsoChild: IAlmFileSystemObjectContent) => {
                if(!fsoChild) {
                    return;
                }
                const parent = this.getFsoParentById(fsoChild.id);

                if (!parent) {
                    return;
                }
                parent.almChecked = false;
                parent.almIntermediateChecked = false;

                if (!value) {
                    const isAnyChildrenChecked = parent.folderContent?.some((fso:IAlmFileSystemObjectContent) => {
                        return fso.almChecked || fso.almIntermediateChecked;
                    });
                    if (isAnyChildrenChecked) {
                        parent.almIntermediateChecked = true;
                    }
                } else {
                    const isAllChildrenChecked = parent.folderContent?.every((fso:IAlmFileSystemObjectContent) => {
                        return fso.almChecked;
                    });
                    if (isAllChildrenChecked) {
                        parent.almChecked = true;
                    } else {
                        const hasSelectedChildren = parent.folderContent?.some((fso:IAlmFileSystemObjectContent) => {
                            return fso.almChecked || fso.almIntermediateChecked;
                        });
                        if (hasSelectedChildren) {
                            parent.almIntermediateChecked = true;
                        }
                    }
                }
                toggleAllFsoParents(parent);
            };

            toggleAllFsoChildrens(fsoChild);
            toggleAllFsoParents(fsoChild);
        },
        getTenantNameById(tenantId: string | number): string {
            const tenant = this.almTenants?.find((t: TenantDTO) => String(t?.id) === String(tenantId));
            return tenant ? tenant?.name : '';
        },
}
})
</script>
<style scoped>
:deep(.is-global) {
    display: none;
}

:deep(.alm-calm-tabs) {
    height: 100%;
}

.alm-forms-tab{
    overflow: auto;
}

:deep(.alm-calm-tabs .tabs-items .tab-item.tab-active) {
    border-color: transparent;
}

:deep(.alm-calm-tabs .tabs-items) {
    height: 56px;
    align-items: center;
    flex-shrink: 0;
    pointer-events: none;
}

:deep(.alm-calm-tabs .tabs-items .tab-item) {
    padding-left: 0;
    padding-right: 0;
    margin-left: 0;
    margin-right: 0;
}

.calm-title {
    display: flex;
    align-items: center;
    height: 56px;
    padding-left: 16px;
    position: absolute;
}

.calm-title h3 {
    margin-bottom: 0;
    margin-left: 16px;
}

.calm-form {
    width: 518px;
    margin-top: 90px;
    justify-self: center;
}

.form-input-description {
    margin: 0;
    margin-top: 2px;
    font-size: 0.8125rem;
}

.form-input-description:first-child {
    margin-top: 8px;
}

.f-textarea {
    resize: none;
    border: none;
    border-bottom: 1px solid var(--neutral-manatee);
    background: var(--accent-color4);
    outline: none;
    border-radius: 2px;
    padding-left: 12px;
    padding-right: 12px;
}

.f-textarea:focus {
    border-bottom: 2px solid var(--primary-blue);
}

.f-textarea:hover {
    background-color: var(--neutral-mischka);
}

.f-textarea::placeholder {
    color: var(--foreground-primary);
    opacity: 0.6;
}

.has-error .f-textarea {
    border-bottom-color: var(--ant-error-color);
}

:deep(.has-error .ant-input-affix-wrapper) {
    border-bottom-color: var(--ant-error-color) !important;
}

:deep(.ant-input-suffix){
    align-self: center;
}

:deep(.has-error label) {
    color: var(--ant-error-color);
}

.error-description {
    color: var(--ant-error-color);
}

:deep(.has-error .p-dropdown) {
    border-bottom-color: var(--ant-error-color);
}

.calm-form :deep(.ant-input::placeholder) {
    font-style: initial;
    color: var(--foreground-primary);
    opacity: 0.6;
}

.calm-form :deep(.ant-input-disabled) {
    color: var(--foreground-primary);
}

.calm-items-wrapper {
    display: flex;
    height: 100%;
}

.calm-items-wrapper .calm-left-sidebar {
    width: 352px;
    border-right: solid 1px var(--thin-border);
    padding: 0 8px 12px 8px;
    overflow-y: auto;
    flex-shrink: 0;
}

.calm-items-wrapper .calm-center-content {
    flex-grow: 1;
    padding: 0 16px 16px;
    overflow: auto;
}

.calm-items-wrapper .calm-right-sidebar {
    display: flex;
    flex-direction: column;
    gap: 24px;
    width: 352px;
    border-left: solid 1px var(--thin-border);
    padding: 16px;
    flex-shrink: 0;
}

.calm-search {
    padding-top: 12px;
    position: sticky;
    top: 0;
    z-index: 1;
    background: var(--background-primary);
}

.fso-wrapper :deep(.ant-checkbox-wrapper:hover),
.fso-wrapper :deep(.ant-checkbox-wrapper:focus),
.fso-wrapper :deep(.ant-checkbox-wrapper:has(.ant-checkbox-checked)) {
    background: var(--row-hover);
}

.child-fso-header,
.fso-wrapper :deep(.ant-checkbox-wrapper) {
    padding: 2px 16px;
    display: flex;
    border-bottom: 1px solid var(--thin-border);
}

.child-fso-header > span,
.calm-breadcrumb {
    font-size: 0.875rem;
    font-weight: 600;
}

.child-fso-header .w-60 {
    width: 60px;
    margin-right: 6px;
}

.child-fso-header .w-150 {
    width: 150px;
    margin-right: 62px;
}

.fso-wrapper :deep(.ant-checkbox-wrapper) {
    width: 100%;
}

.fso-wrapper :deep(.ant-checkbox ~ span) {
    width: 100%;
    padding: 0;
}

.flex-grow-1 {
    flex-grow: 1;
    margin-left: 16px;
}

.fso-wrapper :deep(.fso) {
    width: 100%;
}

.calm-left-sidebar :deep(.fso .fso-main) {
    grid-template-columns: 24px 24px fit-content(100%) min-content !important;
}

.fso-wrapper :deep(.fso .fso-main) {
    padding-left: 16px;
    pointer-events: none;
}

.calm-center-toolbar-right-section, .calm-center-toolbar-items-content {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-left: 12px;
}

.calm-center-toolbar-source-content {
    display: flex;
    flex-direction: row;
    align-items: center;
    border-right: solid 1px var(--thin-border);
    padding-right: 12px;
}

.calm-center-toolbar-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 16px;
    padding-bottom: 16px;
    border-bottom: solid 1px var(--thin-border);
}

.calm-center-toolbar {
    display: flex;
    flex-direction: column;
    position: sticky;
    top: 0;
    z-index: 1;
    background: var(--background-primary);
}

.calm-center-toolbar h2, .calm-center-toolbar-right-section h4 {
    margin: 0;
}

.calm-center-toolbar-right-section h4 {
    margin-right: 5px;
}

.calm-breadcrumb .br-button {
    cursor: pointer;
}

.calm-breadcrumb {
    display: flex;
    align-items: center;
    overflow: auto;
    padding: 16px 0;
}

:deep(.f-breadcrumb) {
    height: auto;
    flex-wrap: wrap;
}

:deep(.ant-breadcrumb-separator) {
    margin: 0;
}

:deep(.breadcrumb-item .ant-breadcrumb-link) {
    white-space: nowrap;
    overflow: hidden;
}
</style>

<style>
.alm-calm-modal {
    width: 100% !important; /*Need to overwrite inline style */
    max-width: 100%;
    height: 100vh;
    top: 0;
    padding: 0;
    margin: 0;
    min-width: 520px;
}

.alm-calm-modal .ant-modal-content {
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: auto;
}

.alm-calm-modal .ant-modal-body {
    flex-grow: 1;
    overflow-y: auto;
}

.alm-calm-modal .ant-modal-header {
    display: none;
}

.alm-calm-modal .ant-modal-close {
    display: none;
}

.alm-calm-modal .ant-modal-footer {
    padding: 16px;
    border-top: solid 1px var(--accent-color3);
}

.alm-calm-modal .ant-spin-nested-loading {
    height: 100%;
}

.alm-calm-modal .ant-spin-nested-loading .ant-spin-container {
    height: 100%;
}
</style>
